import { useMemo } from 'react';
import { getBackendNameArr, getBackendNameList } from '../AlertsConfig/alertConfig.utils';

export default function useCreateDisable(selectValArr, dimensionData) {
  const disableCreateBtn = useMemo(() => {
    const dimensionsSelect = getBackendNameArr(selectValArr);
    const hasAllSelectVal = dimensionsSelect.every(Boolean);
    let hasExistingCombination = false;
    if (hasAllSelectVal) {
      dimensionData.forEach(({ backendName }) => {
        const backendNameList = getBackendNameList(backendName);
        if (!hasExistingCombination) {
          hasExistingCombination = backendNameList.every(item => dimensionsSelect.includes(item));
        }
      });
    }

    return !hasAllSelectVal || hasExistingCombination;
  }, [selectValArr, dimensionData]);

  return disableCreateBtn;
}
